import { useState, useRef, useEffect } from "react";
import {
  Button,
  Typography,
  Stack,
  TextField,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  Alert,
  Modal,
  Dialog,
  DialogContent,
  DialogTitle,
  Autocomplete,
  DialogActions,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Block from "../../components/Block";
import SearchIcon from "@mui/icons-material/Search";
import DataTable from "../../components/DataTable";
import { Link } from "react-router-dom";
import {
  createClosure,
  deleteClosure,
  listClosures,
  listSettings,
} from "../../distflowAPI/settingsApi";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import dayjs from "dayjs";
import { useModal } from "mui-modal-provider";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
const defaultColDef = {
  flex: 1,
  filter: false,
  floatingFilter: false,
};

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function Settings() {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Block>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Custom Holidays" {...a11yProps(0)} />
            <Tab label="System Parameters" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <DistflowClosure />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          Item Two
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <SettingsParams />
        </CustomTabPanel>
      </Box>
    </Block>
  );
}
const SettingsParams = () => {
  const columnDefs = [
    //product_image,
    {
      headerName: "Code",
      field: "code",
      autoHeight: true,
      cellRendererSelector: (params) => {
        return {
          component: SettingCodeRenderer,
        };
      },
      filter: false,
      flex: 2,
      width: 450,
    },
    {
      headerName: "Notes",
      field: "notes",
      autoHeight: true,
      cellRendererSelector: (params) => {
        return {
          component: SettingsNotesRenderer,
        };
      },
      filter: false,
      flex: 7,
    },
  ];
  const [rawTableData, setrawTableData] = useState([]);
  const gridRef = useRef();

  function updateTable() {
    listSettings().then((res) => {
      setrawTableData(res.data.results);
    });
  }
  useEffect(() => {
    updateTable();
  }, []);
  return (
    <>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "space-between", sm: "center" }}
        justifyContent="space-between"
        spacing={1.5}
        my="25px"
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing="15px"
        >
          <Button
            className="btn-height"
            to="/settings/create"
            component={NavLink}
            variant="contained"
          >
            Add New
          </Button>
          <Button className="btn-height" variant="outlined">
            Delete Selected
          </Button>
        </Stack>
      </Stack>
      <Alert severity="error">
        DANGER ZONE: Do not modify unless you know exactly what you're doing
      </Alert>
      <Box className="table-wrapper">
        <DataTable
          rowData={rawTableData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          rowHeight={53}
          headerHeight={60}
          ref={gridRef}
        />
      </Box>
    </>
  );
};

export default Settings;

function SettingCodeRenderer(params) {
  return (
    <span className="my-renderer">
      <Link
        to={`/settings/${params.data.id}`}
        style={{ textDecoration: "none" }}
      >
        {params.data.code}
      </Link>
    </span>
  );
}

function SettingsNotesRenderer(params) {
  return <span>{params.data.notes}</span>;
}

function ActionsRenderer({ params, fetchData }) {
  const [isDeleting, setIsDeleting] = useState(false);
  return (
    <Button
      onClick={() => {
        setIsDeleting(true);
        deleteClosure(params?.data?.id).then((res) => fetchData());
      }}
    >
      {isDeleting ? "Deleting" : "Delete"}
    </Button>
  );
}
function DistflowClosure({}) {
  const { showModal } = useModal();
  const gridRef = useRef();
  const [closureDates, setClosureDates] = useState([]);
  function fetchData() {
    listClosures().then((res) => setClosureDates(res.data.results));
  }
  useEffect(() => {
    fetchData();
  }, []);
  const columnDefs = [
    //product_image,
    {
      headerName: "Notes",
      field: "note",
      flex: 2,
    },
    {
      headerName: "Start Date",
      field: "start_date",
      flex: 1,
      valueFormatter: (params) =>
        params.value ? dayjs(params.value).format("MM/DD/YYYY h:mm A") : "",
    },
    {
      headerName: "End Date",
      field: "end_date",
      flex: 1,
      valueFormatter: (params) =>
        params.value ? dayjs(params.value).format("MM/DD/YYYY h:mm A") : "",
    },
    {
      headerName: "Level",
      field: "level",
      flex: 1,
    },
    {
      headerName: "Erev Rules",
      field: "erev_rules",
      flex: 1,
    },
    {
      headerName: "Actions",
      cellRenderer: (params) => (
        <ActionsRenderer params={params} fetchData={fetchData} />
      ),
      flex: 1,
    },
  ];
  return (
    <Stack spacing={2}>
      <Button
        variant="contained"
        sx={{ maxWidth: 180 }}
        onClick={() => showModal(AddNewClosureModal, { fetchData })}
      >
        Add New
      </Button>
      <DataTable
        rowData={closureDates}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        rowHeight={53}
        headerHeight={60}
        ref={gridRef}
      />
    </Stack>
  );
}

function AddNewClosureModal(props) {
  const { ...restProps } = props;
  const [data, setData] = useState({
    start_date: dayjs(),
    end_date: dayjs().add(7, "days"),
    note: "Were closed for holidays",
    erev_rules: {
      value: false,
      label: "NO",
    },
    level: {
      value: "CUSTOMER_PORTAL",
      label: "Customer Portal",
    },
  });
  function handleCreate() {
    let good = [("start_date", "end_date", "note", "level")].map((item) => {
      if (!data[item]) {
        alert(item + " is required");
        good = false;
      }
    });
    if (!good) {
      return;
    }
    createClosure({
      start_date: data.start_date.format("YYYY-MM-DDTHH:mm:ss"),
      end_date: data.end_date.format("YYYY-MM-DDTHH:mm:ss"),
      note: data.note,
      erev_rules: data.erev_rules.value,
      level: data.level.value,
    }).then((res) => {
      console.log("res: ", res);
      props.fetchData();
      props.onClose();
    });
  }
  return (
    <Dialog
      {...restProps}
      maxWidth="sm"
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          width: "100%",
          maxWidth: "1200px",
        },
        zIndex: 1500,
      }}
    >
      <DialogTitle>Add Closure Dates</DialogTitle>
      <DialogContent>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Stack direction={"row"} spacing={2}>
            <Stack>
              <Typography>Start Date</Typography>
              <DateTimePicker
                value={data.start_date}
                onChange={(v) => setData({ ...data, start_date: v })}
                slotProps={{
                  textField: {
                    sx: { minWidth: 265 },
                  },
                }}
              />
            </Stack>
            <Stack>
              <Typography>End Date</Typography>
              <DateTimePicker
                value={data.end_date}
                onChange={(v) => setData({ ...data, end_date: v })}
                slotProps={{
                  textField: {
                    sx: { minWidth: 265 },
                  },
                }}
              />
            </Stack>
          </Stack>
        </LocalizationProvider>
        <Stack direction={"row"} spacing={2} mt={2}>
          <Stack>
            <Typography>Level</Typography>
            <Autocomplete
              classes={{ popper: "autocomplete-popper" }}
              fullWidth
              options={[
                { label: "Both", value: "ALL" },
                { label: "Distflow", value: "DISTFLOW" },
                { label: "Customer Portal", value: "CUSTOMER_PORTAL" },
              ]}
              value={data.level}
              onChange={(e, newValue) => setData({ ...data, level: newValue })}
              renderInput={(params) => <TextField {...params} fullWidth />}
              sx={{
                maxWidth: 265,
                minWidth: 265,
                "& .MuiInputBase-root": {
                  padding: "0 65px 0 9px",
                },
                "& .MuiInputBase-input": {
                  padding: "8.5px 4px 8.5px 5px !important",
                },
                "& .MuiFormControl-root": {
                  minHeight: "40px !important",
                },
              }}
            />
          </Stack>
          <Stack>
            <Typography>Erev rules</Typography>
            <Autocomplete
              options={[
                { label: "YES", value: true },
                { label: "NO", value: false },
              ]}
              value={data.erev_rules}
              onChange={(e, newValue) =>
                setData({ ...data, erev_rules: newValue })
              }
              fullWidth
              renderInput={(params) => <TextField {...params} />}
              sx={{
                maxWidth: 265,
                minWidth: 265,
                "& .MuiInputBase-root": {
                  padding: "0 65px 0 9px",
                },
                "& .MuiInputBase-input": {
                  padding: "8.5px 4px 8.5px 5px !important",
                },
                "& .MuiFormControl-root": {
                  minHeight: "40px !important",
                },
              }}
              classes={{ popper: "autocomplete-popper" }}
            />
          </Stack>
        </Stack>
        <Typography mt={2}>Notes</Typography>
        <TextField
          fullWidth
          value={data.note}
          onChange={(e) => setData({ ...data, note: e.target.value })}
        />
      </DialogContent>
      <DialogActions>
        <Stack direction={"row"} spacing={2}>
          <Button
            variant="contained"
            color="error"
            onClick={() => props.onClose()}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleCreate}>
            Create
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
